import styled from 'styled-components'
import { ASSETS } from '../../../../constants/assets'

export const SideBarItem = styled.div`
  margin-bottom: 24px;

  .SideBar__Item-Title {
    color: ${({ theme }) => theme.webMktNewPalette.black};
    margin-bottom: 16px;
  }

  .SideBar__Item-Body,
  .SideBar__Item-Body > * {
    color: ${({ theme }) => theme.webMktNewPalette.deepBlue[55]};
  }

  .SideBar__Item-Logo {
    width: 280px;
    height: 140px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    ${({ theme }) => theme.breakpoints.down('sm')} {
      width: 200px;
      height: 100px;
    }

    ${({ theme }) => theme.breakpoints.down('xs')} {
      width: 156px;
      height: 78px;
    }

    .SideBar__Item-Logo-File {
      width: 100%;
      height: auto;
    }
  }
`

export const CustomerStoryBackgroundContainer = styled.div`
  background-color: ${({ theme }) => theme.webMktNewPalette.deepBlue[10]};
  padding-top: 64px;
`

export const CustomerStoryBodyOuter = styled.div`
  padding-bottom: 64px;

  .CustomerStory__Tag {
    background: ${({ theme }) => theme.webMktNewPalette.white};
  }

  .SideBar {
    ${({ theme }) => theme.breakpoints.down('sm')} {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      ${SideBarItem} {
        width: calc(50% - 8px);
      }
    }

    ${({ theme }) => theme.breakpoints.down('xs')} {
      flex-direction: column;
      padding-bottom: 64px;

      ${SideBarItem} {
        width: 100%;
        margin-bottom: 16px;

        &:last-of-type {
          margin-bottom: 0;
        }
      }
    }
  }

  .CustomerStory__Body-Container {
    ${({ theme }) => theme.breakpoints.down('sm')} {
      margin: -12px 0;
      width: 100%;
    }

    .CustomerStory__Body-Grid-Item {
      ul {
        list-style: none;
      }

      margin-right: auto;
      margin-left: 126px;

      ${({ theme }) => theme.breakpoints.down('md')} {
        margin-left: 108px;
      }

      ${({ theme }) => theme.breakpoints.down('sm')} {
        margin-left: auto;
      }
    }

    .CustomerStory__SideBar-Grid-Item,
    .CustomerStory__Body-Grid-Item {
      ${({ theme }) => theme.breakpoints.down('sm')} {
        max-width: 548px;
        margin: 0 auto;
      }

      ${({ theme }) => theme.breakpoints.down('xs')} {
        padding: 0;
      }
    }

    .richText-styled-list {
      padding-bottom: 16px;
    }

    ul.richText-styled-list {
      li.richText-styled-list-items {
        margin-bottom: 16px;
        &:nth-last-child(1) {
          margin-bottom: 0;
        }
      }
    }
  }
`
export const CustomerStoryBodyContent = styled.div`
  h2,
  h3 {
    margin: 48px 0 32px 0;
  }

  &:first-child {
    margin-top: 0;
  }

  img {
    &:not(.VideoPlayer__Image-File) {
      margin: 32px 0;
    }
  }

  .VideoPlayer__Image-File {
    width: 100%;
  }

  div > img {
    max-height: 632px;
  }

  p {
    word-wrap: break-word;
    color: rgb(39, 49, 57);
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 24px;
  }

  div {
    margin-top: 16px;
    margin-bottom: 32px;
    padding: 0;
  }

  blockquote {
    background-color: ${({ theme }) => theme.webMktNewPalette.white};
    position: relative;
    margin: 80px 0 60px 0;
    border-left: 0;
    padding: 48px;

    ${({ theme }) => theme.breakpoints.down('xs')} {
      padding: 48px 24px;
    }
  }

  blockquote::before {
    content: '';
    position: absolute;
    top: -30px;
    left: 48px;
    width: 74px;
    height: 56px;
    background-image: url(${ASSETS.BLOCKQUOTE});

    ${({ theme }) => theme.breakpoints.down('xs')} {
      left: 24px;
    }
  }

  blockquote > p {
    color: #273139;
  }

  blockquote p:last-child,
  blockquote p:last-child span {
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    margin-top: 32px;
    margin-bottom: 0;
  }

  blockquote p:first-child {
    font-size: 24px;
    line-height: 36px;
    font-weight: 400;
    letter-spacing: -0.5px;

    ${({ theme }) => theme.breakpoints.down('md')} {
      font-size: 20px;
      line-height: 32px;
    }

    ${({ theme }) => theme.breakpoints.down('sm')} {
      font-size: 20px;
      line-height: 32px;
      letter-spacing: 0px;
    }

    ${({ theme }) => theme.breakpoints.down('xs')} {
      font-size: 20px;
      line-height: 32px;
      letter-spacing: 0px;
    }
  }

  ul {
    list-style: none;
    margin-left: 26px;
    margin-top: 16px;
    margin-bottom: 16px;
  }

  ul > li > p {
    font-weight: 400;
    font-size: 16px;
    color: #273139;
    line-height: 24px;
  }

  ul > li {
    position: relative;
    font-weight: 400;
    font-size: 16px;
    color: #273139;
    line-height: 24px;
    margin-bottom: 32px;
  }

  ul li:before {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.webMktNewPalette.orange[50]};
    position: absolute;
    top: 7px;
    left: -26px;
  }

  ol {
    list-style: decimal;
    margin-left: 20px;
    margin-top: 16px;
    margin-bottom: 32px;
  }

  ol > li > * {
    font-weight: 400;
    font-size: 16px;
    color: #273139;
    line-height: 24px;
    margin-bottom: 16px;
  }
`
